import React from "react";
import "./AboutMe.css";

export default function AboutMe() {
  return (
    <section className="about-section" id="about">
      {/* Intro Paragraph with Icons */}
      <div className="about-intro">
        💻 Computer Engineer | 📝 Storyteller | 🎮 Game Developer | 🧠 AI Enthusiast <br />
        Fueled by ginger shots, deep lore, and a cat who thinks she’s the CEO.
      </div>

      {/* Timeline */}
      <div className="timeline">
        <div className="timeline-item">🎓 Graduated in Computer Engineering</div>
        <div className="timeline-item">📄 Published IEEE Research Papers</div>
        <div className="timeline-item">🏆 Won Dubai Police Game Jam</div>
        <div className="timeline-item">🤖 Built AI-Powered Projects</div>
        <div className="timeline-item">🐈 Became Full-Time Cat Assistant</div>
      </div>

      {/* Flip Cards */}
      <div className="flip-card-container">
        <div className="flip-card">
          <div className="flip-card-inner">
            <div className="flip-card-front">🕹 Game Designer</div>
            <div className="flip-card-back">Crafting worlds with twists. Tears = bonus.</div>
          </div>
        </div>
        <div className="flip-card">
          <div className="flip-card-inner">
            <div className="flip-card-front">🧠 AI Explorer</div>
            <div className="flip-card-back">Trained to outwit AI before it outwits me.</div>
          </div>
        </div>
        <div className="flip-card">
          <div className="flip-card-inner">
            <div className="flip-card-front">😼 Chaos Generator</div>
            <div className="flip-card-back">Yes, I *did* put a cat in your build.</div>
          </div>
        </div>
      </div>
    </section>
  );
}
